/**
 * Copy of the ad landing pages (src/pages/funnel.tsx), in Tom's words. Every word on the funnel page is here, so changing the copy touches this one
 * object. US English only. The page makes no claim about what happens to an account after the trial (a test greps this file for that wording): the
 * terms and the privacy policy carry it. The offer lines (30 days free, 25% off) exist only in a build with VITE_FUNNEL_OFFER=true.
 */
export const FUNNEL_COPY = {
  hero: {
    /** "Free Painting Pricing Template" */
    title: (trade: string) => `Free ${trade} Pricing Template`,
    button: 'Download the template',
  },
  sheet: {
    heading: 'Get your editable Google Sheet pricing guide',
    /** The line under the email box */
    notice: "We'll email you the Google Sheet link.",
    /** What the picture on the right shows */
    imageAlt: (trade: string) => `The ${trade.toLowerCase()} pricing guide as a Google Sheet`,
  },
  signup: {
    heading: 'Save time and get paid faster',
    lead: 'Sign up for Scopie today',
    button: 'Sign up free',
    /** Only with the offer switch on. `free` is the emphasized word of `trial`. */
    offer: {
      trialBefore: 'Get 30 days ',
      free: 'FREE',
      noCard: 'No credit card required',
      discount: 'Get 25% off for your first year',
      small: 'Only start paying after your trial ends. Cancel anytime, no commitment required.',
    },
  },
  /** On /pricing?offer=...: the same offer, one line */
  banner: 'Your offer: 30 days free, then 25% off for your first year. No credit card required to get started.',
  /** On the plan cards of /pricing?offer=...: the prices (computed by discountedCents in src/marketing/funnel-offer.ts from the card's own price, never typed here) and the trial length. */
  pricing: {
    /** Next to the discounted price */
    discountLabel: '25% off your first year',
    /** Read by screen readers before the struck-out normal price (the strike itself is only a look) */
    priceWas: 'Was',
    /** The trial line: the old length struck out, then the new one. `trialSr` is what screen readers hear instead of the two. */
    trialWas: '14',
    trialNow: '30 days free',
    trialSr: '30 days free, was 14',
    /** Shown beside prices, so it says what the free trial is for */
    noCard: 'No credit card required to get started',
  },
  footer: { terms: 'Terms', privacy: 'Privacy' },
} as const;
